module.exports = __webpack_public_path__ + "d3e0862afec34010a2be535559223b05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/twitter-logo.svg
// module id = 470
// module chunks = 0